export class Guid {
    public static validator: RegExp = new RegExp(
        '^[a-z0-9]{8}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{12}$',
        'i'
    );

    public static EMPTY: string = '00000000-0000-0000-0000-000000000000';

    public static isGuid(guid: any): boolean {
        if (!guid) {
            return false;
        }
        const value = guid.toString();
        return guid instanceof Guid || Guid.validator.test(value);
    }

    public static create(): Guid {
        return new Guid(Guid.raw());
    }

    public static createEmpty(): Guid {
        return new Guid(Guid.EMPTY);
    }

    public static parse(guid: string): Guid {
        return new Guid(guid);
    }

    public static raw(): string {
        return crypto.randomUUID();
    }

    private value: string;

    private constructor(guid: string) {
        if (!guid) {
            throw new TypeError('Invalid argument; `value` has no value.');
        }
        this.value = guid;
    }

    public equals(other: Guid): boolean {
        return this.value === other.toString();
    }

    public isEmpty(): boolean {
        return this.value === Guid.EMPTY;
    }

    public toString(): string {
        return this.value;
    }

    public toJSON(): string {
        return this.value;
    }
}
